module.exports = __webpack_public_path__ + "img/5.9b086af6.png";